import { apiRequest } from './api';

const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export interface Media {
    id: string;
    organizationId: string;
    fileName: string;
    fileUrl: string;
    fileType: 'image' | 'video' | 'document';
    fileSize: number;
    agentId?: string;
    agentName?: string;
    promptContent?: string;
    uploadedAt: string;
    uploadedBy: string;
    uploadedByName?: string;
    isOrphan: boolean; // Não utilizada
}

export interface MediaLimitInfo {
    currentCount: number;
    maxMedia: number;
    isUnlimited: boolean;
    canUpload: boolean;
}

class MediaApiService {
    async getAll(): Promise<Media[]> {
        const result = await apiRequest<Media[]>('/Media/GetAll', {
            method: 'GET',
            auth: true,
        });

        if (!result.success) {
            throw new Error(result.error || 'Erro ao buscar mídias');
        }

        return result.data || [];
    }

    async getMediaCount(): Promise<number> {
        const result = await apiRequest<number>('/Media/GetMediaCount', {
            method: 'GET',
            auth: true,
        });

        if (!result.success) {
            throw new Error(result.error || 'Erro ao buscar contagem de mídias');
        }

        return result.data || 0;
    }

    async getMediaLimitInfo(): Promise<MediaLimitInfo> {
        const result = await apiRequest<MediaLimitInfo>('/Media/GetMediaLimitInfo', {
            method: 'GET',
            auth: true,
        });

        if (!result.success) {
            throw new Error(result.error || 'Erro ao buscar informações de limite');
        }

        return result.data!;
    }

    async deleteMedia(id: string): Promise<void> {
        const result = await apiRequest<void>(`/Media/Delete/${id}`, {
            method: 'DELETE',
            auth: true,
        });

        if (!result.success) {
            throw new Error(result.error || 'Erro ao deletar mídia');
        }
    }

    async checkOrphans(): Promise<{ message: string }> {
        const result = await apiRequest<{ message: string }>('/Media/CheckOrphans', {
            method: 'POST',
            auth: true,
        });

        if (!result.success) {
            throw new Error(result.error || 'Erro ao verificar mídias não utilizadas');
        }

        return result.data!;
    }

    async updateMediaAgent(mediaId: string, agentId: string | null): Promise<void> {
        const result = await apiRequest<void>('/Media/UpdateAgent', {
            method: 'POST',
            auth: true,
            body: JSON.stringify({ mediaId, agentId }),
        });

        if (!result.success) {
            throw new Error(result.error || 'Erro ao atualizar associação da mídia');
        }
    }
}

export const mediaApi = new MediaApiService();
